import React from 'react';
import { Modal, Button } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import icFacebook from '../../assets/ic_facebook@2x.png';

const redirectUri = 'https://tools.insta360.com/live/facebook';
const authUrl = `https://openapi.insta360.com/tools/v1/facebook/getOauthCode?client_id=194165014484164&callback=${redirectUri}`;

@inject('app', 'fb')
@observer
class Auth extends React.Component {
  componentDidMount() {
    const { fb } = this.props;
    const code = this.getCode();
    if (code) {
      setTimeout(() => {
        fb.auth(code, () => {
          this.setState({
            visible: false
          });
        });
      }, 1500);
    }
  }

  getCode = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('code');
    return code;
  };

  render() {
    const { langs, isMobile } = this.props.app 
    const { accessToken, clearToken, userName } = this.props.fb

    return (
      <div>
        <Modal
          title={langs['live_auth_title']}
          visible={accessToken?false:true}
          closable={false}
          footer={null}
        >
          <p>
            {langs['live_auth_t1']}
          </p>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Link to="/live">
              <Button type={'primary'}>{langs['live_auth_back']}</Button>
            </Link>

            <a 
              href={authUrl} 
              style={{
                marginLeft: '16px',
                height: '32px',
                padding: '0 16px',
                backgroundColor: '#4267B2',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                borderRadius: '4px',
                textDecoration: 'none'
              }}
            >
              <img style={{height: '20px', marginRight: '8px'}} src={icFacebook} alt=""/>
              Continue with Facebook
            </a>
          </div>
        </Modal>

        {accessToken&&isMobile?(
          <div style={{ marginTop: '48px', textAlign: 'center' }}>
            {userName?userName:null}
            <a style={{ paddingLeft: '1em' }} onClick={clearToken}>{langs['live_fb_create_user_logout']}</a>
          </div>
        ):null}
      </div>
    );
  }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/views/live/fb/components/auth.js